import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface MicrophoneState {
  recording: boolean;
  connected: boolean;
  micNotFound: boolean;
  micPermissionDenied: boolean;
}

const initialState: MicrophoneState = {
  recording: false,
  connected: false,
  micNotFound: false,
  micPermissionDenied: false,
};

export const microphoneSlice = createSlice({
  name: "microphone",
  initialState,
  reducers: {
    setRecording: (state, action: PayloadAction<boolean>) => {
      state.recording = action.payload;
    },
    setConnected: (state, action: PayloadAction<boolean>) => {
      state.connected = action.payload;
    },
    setMicNotFound: (state, action: PayloadAction<boolean>) => {
      state.micNotFound = action.payload;
    },
    setMicPermissionDenied: (state, action: PayloadAction<boolean>) => {
      state.micPermissionDenied = action.payload;
    },
  },
});

export const {
  setRecording,
  setConnected,
  setMicNotFound,
  setMicPermissionDenied,
} = microphoneSlice.actions;

export default microphoneSlice.reducer;
